import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ArrowForward from '@material-ui/icons/ArrowRightAlt';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

const ShowMoreContainer = styled.div.withConfig({ componentId: 'sc-foqv64-0' })`
  display: flex;
  align-items: center;
  color: ${colors.blueJayWay};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  cursor: pointer;
`;

type Props = {
  onClick: (...args: any[]) => any;
  shouldShowMore: boolean;
};

const ShowMore = ({ onClick, shouldShowMore }: Props) => {
  const { t } = useTranslation();

  const flags = useLDFlags();

  if (!shouldShowMore) return null;

  return (
    <ShowMoreContainer onClick={onClick}>
      {flags.kis511H22022BookingFlow
        ? t('bookingTimeSelector.viewAllAvailability')
        : t('bookingTimeSelector.showMore')}
      <ArrowForward />
    </ShowMoreContainer>
  );
};

export default ShowMore;
